import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import leadBenefit1 from "images/lead-benefit1.png";
import leadBenefit2 from "images/lead-benefit2.png";
import leadBenefit3 from "images/lead-benefit3.png";
import leadBenefit4 from "images/lead-benefit4.png";
import { SuccessButton } from 'components/button';
import Footer from 'components/footer';
import { useForm } from 'react-hook-form';
import { redirectToHome } from '__utils/common-utils';
import { COLOR } from 'constants/colors';
import { FormErrorMessageSpan, InputMintDiv, MintBoxDiv } from 'views/common-styled-components';
import CreateLeadSelector from './create-lead.selector';
import { propsToJS } from '__utils/immutable-to-js';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCreateLead, setFailedToCreateLead, setLeadCreated } from './create-lead.actions';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode, getUserDetails } from '__utils/storage';
import ConfirmationModal from 'components/confirmation-modal';
import { useMediaQuery } from 'react-responsive';
import useFlashToggler from 'hooks/use-flash-toggler';

const CreateLeadOuterCont = styled.div`
    padding: 16px;
    background-color: ${COLOR.GREY_BG};
    padding-bottom: 125px;
`;

const InvestorDetailsCont = styled.div`
    padding: 16px;
`;

const BenefitsCont = styled.div`
    padding: 24px 0;
    .benefit-lead-content {
        margin-top: 24px;
        padding: 0 10px;
    }
    .benefit-lead-box {
        display: grid;
        grid-template-columns: repeat(1, 1fr 5fr);
        margin-bottom: 24px;
        align-items: center;
        img {
            height: 55px;
            width: 50px;
        }
        p {
            font-size: 14px;
            line-height: normal;
            color: ${COLOR.GREY};
            margin-left: 24px;
        }
    }
`;

const CreateLeadSuccessCont = styled.div`
    h3 {
        font-size: 18px;
        font-weight: 600;
        line-height: 1.2222222222222223;
        padding: 0;
        border: none;
    }
    p {
        font-size: 16px;
        line-height: 1.25;
        color: #121617;
        margin: 8px 0 16px;
    }
`;

interface CreateLeadProps {
    type: string
}

const CreateLead: React.FC<CreateLeadProps> = (props: CreateLeadProps) => {

    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flash = useFlashToggler();

    const { register, handleSubmit, formState } = useForm({ mode: 'onChange' });
    const { errors } = formState;

    const [showLeadSuccessMessage, setShowLeadSuccessMessage] = useState<boolean>(false);

    const { leadCreated, failedToCreateLead } = propsToJS(useSelector(CreateLeadSelector));

    useEffect(() => {
        if (leadCreated) {
            setShowLeadSuccessMessage(true);
            dispatch(setLeadCreated(false));
        }
    }, [leadCreated, dispatch]);

    useEffect(() => {
        if (failedToCreateLead) {
            flash.error("Failed to create lead. Please try again later.");
            dispatch(setFailedToCreateLead(false));
        }
    }, [failedToCreateLead, dispatch]);

    const onCreateleadSubmit = (data: any) => {
        dispatch(fetchCreateLead({
            investorName: data.investorName,
            investorMobileNo: data.investorNumber,
            investorEmailId: data.investorEmail,
            investmentAmount: Math.round((+data.investmentCorpus) * 100000),
        }, props.type));
        Mixpanel.track(getEventName("updateInvestorDetails" ,"completed","investorDetails"), {
            agentCode: getAgentCode(),
            user: getUserDetails()
        });
    }

    const LeadSuccessContent = () => {
        return (<CreateLeadSuccessCont>
            <p>
                <span>A premium service lead is created successfully. Turtlemint money expert will soon contact you with a solution.</span>
                <span>&nbsp;You can track leads progress from your Mintpro app.</span>
            </p>
            <div className="fl-right">
                <SuccessButton style={{ width: "100px",marginBottom: "24px" }} onClick={() => redirectToHome()}>Okay</SuccessButton>
            </div>
            <div style={{ clear: "both" }}></div>
        </CreateLeadSuccessCont>);
    }

    return (<CreateLeadOuterCont>
        <form name="createLeadForm" onSubmit={handleSubmit(onCreateleadSubmit)} noValidate>
            <MintBoxDiv style={{ padding: "0px" }} isMobile={isMobile}>
                <InvestorDetailsCont>
                    <InputMintDiv>
                        <label>Customer Full Name</label>
                        <br />
                        <input
                            name="investorName"
                            type="text"
                            ref={register({
                                required: "Please enter name",
                                pattern: {
                                    value: /^[a-zA-Z]+((['. -][a-zA-Z ])?[a-zA-Z]*)*$/,
                                    message: "Please enter a valid name"
                                }
                            })}
                        />
                    {( errors.investorName) ? <FormErrorMessageSpan>{errors.investorName.message}</FormErrorMessageSpan> : null}
                    </InputMintDiv>
                    <InputMintDiv>
                        <label>Customer Mobile No.</label>
                        <br />
                        <input
                            name='investorNumber'
                            type="number"
                            ref={register({
                                required: "Please enter investor number",
                                pattern: {
                                    value: /^[6-9]{1}[0-9]{9}$/,
                                    message: "Please enter a valid mobile number"
                                }
                            })}
                        />
                        {errors.investorNumber ? <FormErrorMessageSpan>{errors.investorNumber.message}</FormErrorMessageSpan> : null}
                    </InputMintDiv>
                    
                    <InputMintDiv>
                        <label>Customer Email ID</label>
                        <br />
                        <input
                            name='investorEmail'
                            type="email"
                            ref={register({
                                required: "Please enter name",
                                pattern: {
                                    value: /^.+@[^.].*\.[a-z]{2,}$/,
                                    message: "Please enter a valid email"
                                }
                            })}
                        />
                        { errors.investorEmail ? <FormErrorMessageSpan>{errors.investorEmail.message}</FormErrorMessageSpan> : null}
                    </InputMintDiv>
                    <InputMintDiv>
                        <label>Investment Amount (in Lakhs)</label>
                        <br />
                        <input
                            name='investmentCorpus'
                            type="number"
                            ref={register({
                                required: "Please enter amount",
                                min: {
                                    value: 1,
                                    message: "Please enter amount"
                                }
                            })}
                        />
                        { errors.investmentCorpus ? <FormErrorMessageSpan>{errors.investmentCorpus.message}</FormErrorMessageSpan> : null}
                    </InputMintDiv>
                </InvestorDetailsCont>
            </MintBoxDiv>
            <BenefitsCont>
                <div>Benefits of creating lead for your client</div>
                <div className="benefit-lead-content">
                    <div className="benefit-lead-box">
                        <img src={leadBenefit1} alt="lead-benefit1" />
                        <p>You can access this investment cart anytime from a lead on your Mintpro dashboard and check its status. </p>
                    </div>
                    <div className="benefit-lead-box">
                        <img src={leadBenefit2} alt="lead-benefit2" />
                        <p>As per regulations, AMFI registered Investment expert will help you confirm &#38; close sale on joint call with client.</p>
                    </div>
                    <div className="benefit-lead-box">
                        <img src={leadBenefit3} alt="lead-benefit3" />
                        <p>Your client can track performance of his investment portfoilio on turtlemintmoney website.</p>
                    </div>
                    <div className="benefit-lead-box">
                        <img src={leadBenefit4} alt="lead-benefit4" />
                        <p>Any client assigned by you will be mapped only to you. You will earn payouts for all his future investments.</p>
                    </div>
                </div>
            </BenefitsCont>
            <Footer>
                <SuccessButton disabled={!formState.isValid}>Submit</SuccessButton>
            </Footer>
        </form>
        {showLeadSuccessMessage ?
        <ConfirmationModal title="Success" modalBody = {<LeadSuccessContent />} closable={false}></ConfirmationModal> : null}
    </CreateLeadOuterCont>);
}

export default CreateLead;